import { Component, OnInit, ViewChild, OnDestroy, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { AppCodeGroup, ControlsParams, UserSessionService, SharedDateService, FormGroupCreationService, FormSettingsService, UIAction, UISessionKeys, getDateObj, getNgBsObj, IDefaults } from '../../shared';
import { ModalService, ToastService, SelectizeComponent } from '../../blocks';
import { CallCenterReservationService, ErPatient, TotalData, CallData, Mark_Leads, MsgTemplate } from './call-center-reservation.service'
import { takeUntil } from 'rxjs/operators';
import { concat, Subject, Subscription } from 'rxjs';
import { AbstractControl, FormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NumberValueAccessor, Validators } from '@angular/forms';
import { NameComponent } from '../../blocks/names/name.component';
import { NameService } from '../../blocks/names/name.service';
import { AddressComponent } from '../../hospitalSetup/address/address.component';
import { IdentityTypeComponent, IIdentity } from '../../blocks/identity_type/identity_type.component';
import { PatientParms, EmergencyParms, OutpatientParms } from '../../shared/search-params';
import { CallDataPopUpComponent } from '../call-data-popup/call-data-popup.component';
import { CallDataPatVisitsServicesComponent } from '../call-data-pat-visits-services/call-data-pat-visits-services.component';
import { CallDataShowLeadsCallsComponent } from '../call-data-show-leads-calls/call-data-show-leads-calls.component';
import { MarkPatExpectedServiceService, MarkPatExpectedServiceSearch } from '../../markting/mark-pat-expected-service/mark-pat-expected-service.service';
import { setUserToLocalStorageFromSession, findInvalidControls } from '../../shared/utility';
import { ContractComponent } from '../../registeration/contracts';
import { CallPatientRepoService } from '../../outpatient/portal-scheduling-management/scheduling-manage-tabs/call-patient-repo.service';
import { ReservationCallComponent } from '../reservation-call/reservation-call.component';
import { IPromotionsMsgLog } from '../../promotions/promotions';
import { PromotionOfferService } from '../../promotions/promotion-offer/promotion-offer.service';
import { ResourceFreeDate } from '../../orders/appointment-booking/appointment-booking.interface';
import { SmsService } from '../../promotions/SmsService/Sms.service';
import { SalesOrderHistoryPopUpComponent } from '../../outpatient/sales-order-history/sales-order-history-popup.component';
import { ResourceFreeDatesComponent } from '../../orders/appointment-booking/resource-free-dates/resource-free-dates.component';
import { DoctorReservationComponent } from '../../blocks/doctor-reservation/doctor-reservation.component';
import { bloodGroup } from '../../stock-transaction/bloodBankReservation/blood-bank-reservation.service';
import { CallCenterService } from '../call-center-list/call-center-list.service';
import { ServiceHistoryComponent } from '../../orders/service-history/service-history.component';
import { RegpatHistoryOnOldSystemComponent } from '../../registeration/old-system-history/old-system-history.component';
import { CallCenterReservationSavedPopupComponent } from './call-center-reservation-saved-data-popup/call-center-reservation-saved-data-popup.component';
@Component({
  selector: 'app-call-center-reservation',
  templateUrl: './call-center-reservation.component.html',
  providers: [NameService, FormGroupCreationService, MarkPatExpectedServiceService]
})

export class CallCenterReservationComponent implements OnInit, OnDestroy, AfterViewInit {
  callCenterReservationForm: UntypedFormGroup;
  namingTranslationSettings: number;
  startDateNgb?: any;
  ngbDayStartHoure;

  controlsParams: ControlsParams;
  cCCallBenficaryCode: number;
  reservationDate; // for datepicker used in two way bind
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  searchObj: EmergencyParms = <EmergencyParms>{};
  messagesLog: IPromotionsMsgLog = <IPromotionsMsgLog>{};
  today = {
    year: new Date().getFullYear,
    month: new Date().getMonth,
    day: new Date().getDay()
  };
  parentId: number;
  dynamicComponent: any;
  callListDynamicComponent: any;
  currentTrans: any;
  @ViewChild('popup') content: any;
  @ViewChild('popup2') content2: any;
  @ViewChild('callListPopup') callListContent: any;
  @ViewChild('name') nameComponent: NameComponent;
  @ViewChild('address') addressComponent: AddressComponent;
  @ViewChild('identity') identityComponent: IdentityTypeComponent;
  @ViewChild('parentServiceSelectize') selectizeParentService: SelectizeComponent;
  @ViewChild('previousPatient') previousPatientSelectize: SelectizeComponent;
  @ViewChild('childServiceSelectize') selectizeChildService: SelectizeComponent;
  @ViewChild('thirdChildServiceSelectize') selectizeThirdChildService: SelectizeComponent;
  @ViewChild('therapeuticCards') contractComponent: ContractComponent;
  @ViewChild('previousCalls') previousCallsSelectize: SelectizeComponent;


  formValAfterSettings: ErPatient = <ErPatient>{};
  obj = {
    'parent': <ErPatient>{}
  };

  @Input() callTypeFlag: number;
  @Input() componentType: number;
  @Input() showExpectedServices: boolean;
  patient: ErPatient;
  patientCodeCards: number;
  editCaller: ErPatient = <ErPatient>{};
  msgTemplate: MsgTemplate = <MsgTemplate>{};

  patientData: any;
  patientCode: any;
  messageId: number;
  patients: ErPatient[];
  callerData: any;
  callData: CallData = <CallData>{};
  patientParms: PatientParms[];
  hiddenFormControls: Array<IDefaults> = [];
  reason: number = 3;
  known: boolean;
  listeningGuid: string = '';
  patnum: number = 1;
  callMainDataArr = [];
  userId: number;
  active: number = 1;
  serachAsCall: number = 1;
  existedPatient: boolean
  editeClientData: any;
  showClientCallData: boolean;
  patNameAr: string
  patNameEn: string;
  patVistSerial: number;
  CallDataList = [];
  addSecMobileNumber: boolean;
  showLeads: boolean;
  markPatExpectedServiceSearchObj = <MarkPatExpectedServiceSearch>{}
  appCodesList = []
  @Input() editeCallDataMode: boolean
  @Input() hideCallSearchCretria: boolean
  @ViewChild('patientSelectize') patientSelectize: SelectizeComponent;
  @ViewChild('CallDataShowLeadsCallsComponent') callDataShowLeadsCallsComponent: CallDataShowLeadsCallsComponent;
  @Output() emitSaveSuccesOrBackStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  cancelRepo: Subscription;
  displayCallerInfo: boolean = false;
  hideSendMessageBox: boolean = false;
  sendMessageFlag: boolean = false;

  constructor(

    public _callRepo: CallPatientRepoService,
    public translate: TranslateService,
    private fb: UntypedFormBuilder,
    private _formServiceSettings: FormSettingsService,
    private _callCenterReservationService: CallCenterReservationService,
    private _toastService: ToastService,

    private _sharedDateService: SharedDateService,
    private _userSessionService: UserSessionService,
    private _callCenterService: CallCenterService,
    private _modalService: ModalService,
    private _MarkPatExpectedServiceService: MarkPatExpectedServiceService,
    private activatedRoute: ActivatedRoute, private _SmsService: SmsService,
  ) {
    this.listeningGuid = 'CallCenterReservation';
    this.controlsParams = new ControlsParams(null, AppCodeGroup.Buttons, true, 'CallCenterReservationComponent', '');
    this.cancelRepo = _callRepo.saveCallCenterReservation$
      .subscribe(res => {
        if (res) {
          this._userSessionService.removeSessionKey('patientTransfer');
          _callRepo.resetData();
          this.resetForm();
        }
      });
  }
  modeType: number
  ngOnInit() {
    console.log('componentType', this.componentType)
    this.modeType = this.activatedRoute.snapshot.params['mode'] ? this.activatedRoute.snapshot.params['mode'] : 0;
    console.log(this.modeType)
    if (this.modeType == 3) {
      this.componentType = 3
      this.showExpectedServices = true
    }
    if (this.editeCallDataMode) {
      this.appCodesList = [1, 304];
    } else {
      this.appCodesList = [1, 2, 304];
    }
    setUserToLocalStorageFromSession();
    // this.getMsgTemplate(); amer hash  15/05/2022
    this.initlizeControls();

    this.getModuleSettings();
    this.initViewComponentForm();
    this.readCallCenterUrlParms();
    this.monthlyReservedSlots();

    this._userSessionService.subscribeToKey$('CallTypeFlag').pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.callTypeFlag = keys.value
          console.log(this.callTypeFlag)
        }
      });

    if (this.componentType == 1) {
      if (this._userSessionService.getSessionKey('callerInfo')) {
        this.callerData = this._userSessionService.getSessionKey<any>('callerInfo');
        this.callerData.reservationDate = this._sharedDateService.convertFromDateToNgBsObject(this.callerData.reservationDate);
        console.log('_____________ this.callerData')
        console.log(this.callerData)
      }
    }
    else if (this.componentType == 2) {
      this.callCenterReservationForm.get('callReason').setValue(4);
      this.reason = 3;
      this.known = true;
    }
    this._userSessionService.getUIState$(UISessionKeys.Transactions).subscribe(state => {
      this.currentTrans = state;
    });
    console.log(this.componentType)
  }


  

  readCallCenterUrlParms() {
    let mobile;
    this.activatedRoute.queryParams.subscribe(params => {
      mobile = params['mobile'];
      console.log(params)
      if (mobile
      ) {
        this.callCenterReservationForm.get('callerPhone').setValue(mobile)
        this.handleCallerPhoneKeyEnter()
      }

    },
      err => console.log(err)
    );
  }

  knownFun() {

  }
  monthlyResrevedSlotsObj: any = <any>{};
  monthlyReservedSlots() {
    this._userSessionService.subscribeToKey$('MonthlyresourceFreeDate').pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.monthlyResrevedSlotsObj = keys.value
          this.callCenterReservationForm.get('reservationDate').setValue(getNgBsObj(this.monthlyResrevedSlotsObj.expectedStartTime));
          console.log(this.monthlyResrevedSlotsObj)
        }
      });
  }

  ngOnDestroy() {
    this.cancelRepo.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.initViewComponentForm();
      let setDefaults = true;
      let _patForEdit = <ErPatient>this._userSessionService.getSessionKey('callerInfo');
      if (_patForEdit && _patForEdit['code'] > 0) {
        setDefaults = false;
      };
      this.setDefaultsAndValidators(setDefaults);



      setTimeout(() => {
        this.formValAfterSettings = <ErPatient>Object.assign({}, this.callCenterReservationForm.value);
        this.handelInitParms(_patForEdit, false);
        if (this.callerData) {
          this.setControls(this.callerData);
        }
      }, 1000);
    }, 0);
  }
  multiSlotFlag: boolean
  goBackToHomePageFlag :  number;
  getModuleSettings() {
    this._callCenterReservationService.getStockModuleSettings({ moduleId: 42 })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {

        if (c.data && c.data.length > 0) {
          if (c.data[0])
            this.namingTranslationSettings = +c.data[0]['namingTranslationSettings'];

          console.log(c.data[0]);
          console.log(this.namingTranslationSettings);
        }
      });
    this._callCenterReservationService.getStockModuleSettings({ moduleId: 5410 })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {

        if (c.data && c.data.length > 0) {
          if (c.data[0])
            this.multiSlotFlag = +c.data[0]['multiSlotFlag'] == 1 ? true : false;
             this.goBackToHomePageFlag = +c.data[0]['goBackToHomePage']
        }
      });
    this._callCenterReservationService.getStockModuleSettings({ moduleId: 10123 })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {

        if (c.data && c.data.length > 0) {
          if (c.data[0])
            this.sendMessageFlag = +c.data[0]['sendMsgFlag'] == 1 ? true : false;
        }
      });
  }

  onClicked(e: number): void {
    switch (e) {
      case 1: //save code
      case -1000://save
        this.save();
        break;
      case 2:
        this.goBack();
        break;
      default:
        this.cancelRegister();
        break;
      case 6783://save
        this.getReservationsTime();
        break;
    }
  }


  handelInitParms(_patForEdit: ErPatient, resetFlag: boolean) {
    if (_patForEdit && _patForEdit['code'] > 0) {
      this.patientCode = _patForEdit['code'];


    } else if (_patForEdit && _patForEdit['AddNew']) {
      this.patientCode = null;
    }

  }

  //---------------------------------------------------------------------------------------------------------------------
  /**
   * call after identity value change and emit object contain gender birth place and date for egyption id
   * @param event
   */
  identityValueInfoEmitted(event) {

    this.callCenterReservationForm.patchValue({
      birthDateNgb: this._sharedDateService.convertFromDateToNgBsObject(event.birthDate),
      birthPlace: event.birthPlace,
      gender: event.gender,
    });
  }

  //---------------------------------------------------------------------------------------------------------------------
  initlizeControls() {
    let date = this._sharedDateService.convertFromDateToNgBsObject(new Date());
    let x = new Date();
    this.callCenterReservationForm = this.fb.group({
      code: 0,
      dateHijri: new Date(),
      customCode: [''],
      oldCode: '',
      name: this.fb.group({}),
      therapeuticCards: this.fb.group({}),
      address: this.fb.group({}),
      identity: this.fb.group({}),
      gender: null,
      birthDateNgb: null,
      birthPlace: [''],
      homePhone: '',
      mailAddress: [''],
      mobile: [''],
      mobile2: [''],
      fatherName: '',
      motherName: '',
      nickName: '',
      parentId: '',
      employeeId: '',
      fileNo: '',
      religionId: [''],
      maritalStatus: [''],
      bloodGroup: '',
      rhValue: '',
      stopFlag: '',
      vipFlag: '',
      mortaliyFlag: '',
      mortalityDate: '',
      vipLevel: '',
      dateHijriNgb: null,
      mortalityDateNgb: null,
      placeCode: '',
      startDateNgb: '',
      ngbDayStartHoure: '',
      reservationDate: ['', Validators.required],
      callerName: '',
      callerPhone: '',
      callerAddress: '',
      nationalityId: '',
      callNotes: [''],
      callSort: [''],
      callReason: 3,
      callResult: [''],
      specialization: [''],
      howToReachUs: null,
      branchAddress: null,
      reservationType: 2,
      callmethod: 1,
      serviceCode: '',
      serviceName: '',
      visitSerial: '',
      approxAge: '',
      patCode: null,
      patientServiceLevelOne: '',
      patientServiceLevelTwo: '',
      patientServiceLevelThree: '',
      expectedDate: date,
      doctorID: '',
      cost: '',
      futureCallExpectedAfterDays: '',
      leadType: 1,
      clientCode: '',
      docId: '',
      anesthesiologist: '',
      clinicCode: '',
      serial: 0,
      previousPatient: '',
      customerId: '',
      secoundMobile: '',
      device: '',
      complaintsDesc: '',
      medicalCompliant: '',
      complaints: '',
      perviousCalling:''

    });
    this.callCenterReservationForm.get('reservationDate').valueChanges.pipe
      (takeUntil(this.ngUnsubscribe)).subscribe(selectedValue => {
        this.setOutpatientParms();
      });
  }

  getCallResCode(callResCode) {
    if (callResCode && callResCode.code == 6) {
      this.callCenterReservationForm.controls['reservationDate'].clearValidators()
    }
  }

  contractValueInfoEmitted(contractId: any) {
    if (contractId) {
      this.callCenterReservationForm.get('therapeuticCards.contractId').setValue(contractId);
    }

  }

  setControls(callerData) {
    if (callerData) {
      if (callerData.patCode) {
        this.existedPatient = true;
      }
      //------------------------------------------CALLER COMPONENT---------------------------------------------------------------------------


      this.callCenterReservationForm.get('code').setValue(callerData.code);
      this.callCenterReservationForm.get('serial').setValue(callerData.serial);
      this.callCenterReservationForm.get('callerPhone').setValue(callerData.phoneNumber);
      this.callCenterReservationForm.get('callResult').setValue(callerData.callResult);
      this.callCenterReservationForm.get('reservationType').setValue(callerData.reservationType);
      this.callCenterReservationForm.get('callmethod').setValue(callerData.callmethod);
      this.callCenterReservationForm.get('gender').setValue(callerData.gender);
      this.callCenterReservationForm.get('reservationDate').setValue(callerData.reservationDate);
      this.callCenterReservationForm.get('callReason').setValue(callerData.callReason);
      this.callCenterReservationForm.get('specialization').setValue(callerData.specialization);
      this.callCenterReservationForm.get('branchAddress').setValue(callerData.branchAddress);

      this.callCenterReservationForm.get('howToReachUs').setValue(callerData.howToReachUs);
      this.callCenterReservationForm.get('parentId').setValue(callerData.parentId);
      this.callCenterReservationForm.get('callNotes').setValue(callerData.notes);
      this.callCenterReservationForm.get('callerAddress').setValue(callerData.address);
      this.callCenterReservationForm.get('docId').setValue(callerData.docId);
      this.callCenterReservationForm.get('anesthesiologist').setValue(callerData.anesthesiologist);
      this.callCenterReservationForm.get('serviceCode').setValue(callerData.serviceCode);
      this.callCenterReservationForm.get('mobile').setValue(callerData.mobile);
      this.callCenterReservationForm.get('complaints').setValue(callerData.complaints);
      this.callCenterReservationForm.get('complaintsDesc').setValue(callerData.complaintsDesc);
      this.callCenterReservationForm.get('medicalCompliant').setValue(callerData.medicalCompliant);

      //------------------------------------------NAME COMPONENT---------------------------------------------------------------------------
      if (this.nameComponent) {
        this.callCenterReservationForm.get('name.fnameEn').setValue(callerData.fnameEn);
        this.callCenterReservationForm.get('name.snameEn').setValue(callerData.snameEn);
        this.callCenterReservationForm.get('name.tnameEn').setValue(callerData.tnameEn);
        this.callCenterReservationForm.get('name.lnameEn').setValue(callerData.lnameEn);
        this.callCenterReservationForm.get('name.fnameAr').setValue(callerData.fnameAr);
        this.callCenterReservationForm.get('name.snameAr').setValue(callerData.snameAr);
        this.callCenterReservationForm.get('name.tnameAr').setValue(callerData.tnameAr);
        this.callCenterReservationForm.get('name.lnameAr').setValue(callerData.lnameAr);
        this.callCenterReservationForm.get('name.titleCode').setValue(callerData.titleCode);
      }
      //------------------------------------------ADDRESS COMPONENT---------------------------------------------------------------------------
      if (this.addressComponent) {
        this.callCenterReservationForm.get('address.countryCode').setValue(callerData.countryCode);
        this.callCenterReservationForm.get('address.govCode').setValue(callerData.govCode);
        this.callCenterReservationForm.get('address.cityCode').setValue(callerData.cityCode);
        this.callCenterReservationForm.get('address.villageCode').setValue(callerData.villageCode);
        this.callCenterReservationForm.get('address.nationalityId').setValue(callerData.nationalityId);
        this.callCenterReservationForm.get('address.fullAddressAr').setValue(callerData.fullAddressAr);
        this.callCenterReservationForm.get('address.fullAddressEn').setValue(callerData.fullAddressEn);
      }
      //------------------------------------------IDENTITY COMPONENT---------------------------------------------------------------------------
      if (this.identityComponent) {
        this.callCenterReservationForm.get('identity.identityType').setValue(callerData.identityType);
        this.callCenterReservationForm.get('identity.identityValue').setValue(callerData.identityValue);
        this.identityValueInfoEmitted(callerData);
        this.callCenterReservationForm.get('identity.gender').setValue(callerData.gender);
        this.callCenterReservationForm.get('identity.birthDate').setValue(callerData.birthDate);
        this.callCenterReservationForm.get('identity.birthPlace').setValue(callerData.birthPlace);
      }
      //------------------------------------------CONTRACT COMPONENT---------------------------------------------------------------------------
      if (this.contractComponent) {
        this.callCenterReservationForm.get('therapeuticCards.contractId').setValue(callerData.contractId);
        this.callCenterReservationForm.get('therapeuticCards.cardNo').setValue(callerData.cardNo);
        let strDate = getNgBsObj(callerData.startDate)
        let endDate = getNgBsObj(callerData.endDate)
        this.callCenterReservationForm.get('therapeuticCards.startDate').setValue(strDate);
        this.callCenterReservationForm.get('therapeuticCards.endDate').setValue(endDate);
        this.callCenterReservationForm.get('therapeuticCards.policyNumber').setValue(callerData.policyNumber);
      }
      //------------------------------------Leads
      this.callCenterReservationForm.get('doctorID').setValue(callerData.doctorID);
      this.callCenterReservationForm.get('leadType').setValue(callerData.leadType);

    }
  }
  /**
   * used to init form group that used in views component
   * call after view init
   */
  initViewComponentForm() {
    if (this.nameComponent) {
      this.callCenterReservationForm.setControl('name', this.nameComponent.getFormGroup());
    }
    if (this.addressComponent) {
      this.callCenterReservationForm.setControl('address', this.addressComponent.getAddressForm());
    }
    if (this.identityComponent) {
      this.callCenterReservationForm.setControl('identity', this.identityComponent.getIdentityForm());
    }
    if (this.contractComponent) {
      this.callCenterReservationForm.setControl('therapeuticCards', this.contractComponent.getTherapeuticCardsFormGroup());
    }
  }


  onParentServiceClicked(selectedItem: any): void {
    if (selectedItem && selectedItem != null) {
      this.selectizeChildService.setFastSearchKey('ParentId', selectedItem.code);
      this.callCenterReservationForm.get('serviceName').setValue(selectedItem.nameAr)
    } else {
      if (this.selectizeChildService)
        this.selectizeChildService.setFastSearchKey('ParentId', null);
    }
    if (this.selectizeChildService) {
      this.selectizeChildService.clearItems();
      this.selectizeChildService.clear();
      this.selectizeThirdChildService.clearItems();
      this.selectizeThirdChildService.clear();
    }
  }

  onChildServiceClicked(selectedItem: any): void {
    if (selectedItem && selectedItem != null) {
      this.selectizeThirdChildService.setFastSearchKey('ParentId', selectedItem.code);
      this.callCenterReservationForm.get('serviceName').setValue(selectedItem.nameAr)
    }
    else {
      if (this.selectizeThirdChildService)
        this.selectizeThirdChildService.setFastSearchKey('ParentId', null);
    }
    if (this.selectizeThirdChildService) {
      this.selectizeThirdChildService.clearItems();
      this.selectizeThirdChildService.clear();
    }
  }

  onThirdChildServiceClicked(selectedItem: any): void {
    if (selectedItem && selectedItem != null) {
      this.callCenterReservationForm.get('serviceName').setValue(selectedItem.nameAr)
    }
  }

  getContractFormValue() {
    if (this.contractComponent) {
      let _formVal = this.contractComponent.therapeuticCardsForm.value;
      _formVal.startDate = getDateObj(_formVal.startDate)
      _formVal.endDate = getDateObj(_formVal.endDate)
      return _formVal;
    }
    else
      return null;
  }

  //---------------------------------------------------------------------------------------------------------------------

  save() {

    if (this.contractComponent && !this.displayCallerInfo) {
      let controls = this.contractComponent.therapeuticCardsForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          let _child = <UntypedFormControl>(controls[name])
          _child.clearValidators();
        }

      }
    }
    if (this.addressComponent && !this.displayCallerInfo) {
      let controls = this.addressComponent.addressForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          let _child = <UntypedFormControl>(controls[name])
          _child.clearValidators();
        }

      }
    }
    let patientData: TotalData = this.prepareDataToSave();
    this.callApiToSave(patientData);
  }

  prepareDataToSave(): TotalData {
    this.addSecMobileNumber = false;
    if (this.callerData && this.callerData.serial > 0 && this.callData.dataStatus != 1)
      this.callData.serial = this.callerData.serial;
    else {
      this.callData.serial = -1

    }

    this.callData.address = this.callCenterReservationForm.value.callerAddress;
    this.callData.callerName = this.callCenterReservationForm.value.callerName;
    this.callData.phoneNumber = this.callCenterReservationForm.value.callerPhone ? this.callCenterReservationForm.value.callerPhone : this.callCenterReservationForm.value.mobile;
    this.callData.secoundMobile = this.callCenterReservationForm.value.secoundMobile;
    this.callData.notes = this.callCenterReservationForm.value.callNotes;
    this.callData.complaints = this.callCenterReservationForm.value.complaints;
    this.callData.complaintsDesc = this.callCenterReservationForm.value.complaintsDesc;
    this.callData.medicalCompliant = this.callCenterReservationForm.value.medicalCompliant;
    this.callData.linkedCallSerial = this.callCenterReservationForm.value.perviousCalling;


    this.callData.callSort = this.callCenterReservationForm.value.callSort;
    this.callData.callReason = +this.callCenterReservationForm.value.callReason;
    this.callData.callResult = this.callCenterReservationForm.value.callResult;
    this.callData.reservationType = this.callCenterReservationForm.value.reservationType;
    this.callData.callmethod = this.callCenterReservationForm.value.callmethod;
    this.callData.reservationDate = this.callCenterReservationForm.value.reservationDate;
    this.callData.device = this.callCenterReservationForm.value.device;
    this.callData.docId = this.callCenterReservationForm.value.docId;
    if (this.callData.docId) {

      this.callData.entityType = 3;
    }
    if (this.callData.device) {

      this.callData.entityType = 4;
    }
    this.callData.anesthesiologist = this.callCenterReservationForm.value.anesthesiologist;
    this.callData.serviceCode = this.callCenterReservationForm.value.serviceCode;
    this.callData.callTypeFalg = this.callTypeFlag
    this.callData.cCCallBeneficiarySerial = this.callerData ? this.callerData.ccCallBeneficiarySerial : null;
    this.callData.patCode = this.callerData ? this.callerData.patCode : null;
    this.callData.callTypeFalg = this.callTypeFlag
    this.callData.specialization = +this.callCenterReservationForm.value.specialization;
    this.callData.clinicCode = +this.callCenterReservationForm.value.clinicCode;
    this.callData.expectedStartTime = this.currentFreeDate.expectedStartTime ? this.currentFreeDate.expectedStartTime : this.monthlyResrevedSlotsObj.expectedStartTime
    this.callData.expectedEndTime = this.currentFreeDate.expectedEndTime ? this.currentFreeDate.expectedEndTime : this.monthlyResrevedSlotsObj.expectedEndTime
    this.callData.minutesPerSlot = this.currentFreeDate.minutesPerSlot ? this.currentFreeDate.minutesPerSlot : this.monthlyResrevedSlotsObj.minutesPerSlot

    this.callData.branchAddress = this.callCenterReservationForm.value.branchAddress;

    if (this.reason == 1) {
      this.callData.serviceCode = this._userSessionService.getSessionKey<any>('serviceCode');
    }

    let therapeuticCardsValue = this.getContractFormValue()

    let patientdata = <TotalData>{
      callMainData: null,
      therapeuticCards: therapeuticCardsValue,
      callData: !this.showExpectedServices ? this.callData : null,
      mark_Leads: this.showExpectedServices ? <Mark_Leads>{} : null
    };

    if (!this.existedPatient) {
      for (var i = 0; i < this.patnum; i++) {
        this.callMainDataArr[i] = this.getPatientFromForm();
      }
      patientdata.callMainData = this.callMainDataArr;
    }

    if (this.showExpectedServices) {
      patientdata.mark_Leads.doctorID = this.callCenterReservationForm.value.doctorID
      patientdata.mark_Leads.discountType = 0;
      patientdata.mark_Leads.doctorID = this.callCenterReservationForm.value.doctorID
      patientdata.mark_Leads.cost = this.callCenterReservationForm.value.cost
      patientdata.mark_Leads.futureCallExpectedAfterDays = this.callCenterReservationForm.value.futureCallExpectedAfterDays
      this.formValAfterSettings.mobile = this.callCenterReservationForm.value.mobile;
      this.formValAfterSettings.mobile2 = this.callCenterReservationForm.value.mobile2;
      patientdata.mark_Leads.leadType = this.callCenterReservationForm.value.leadType
      patientdata.mark_Leads.serviceName = this.callCenterReservationForm.value.serviceName
      patientdata.mark_Leads.serviceID = this.callCenterReservationForm.value.serviceID
      patientdata.mark_Leads.expectedDate = getDateObj(this.callCenterReservationForm.value.expectedDate)
      patientdata.mark_Leads.discountType = 0;
    }
    if ((!this.nameComponent.nameForm.value.fnameAr ||
      !this.nameComponent.nameForm.value.snameAr) && !this.existedPatient) {
      this._toastService.activateMsg('UI417');
      return;
    }

    //sayed
    if (!this.callCenterReservationForm.value.mobile && !this.existedPatient) {
      this._toastService.activateMsg('UI410');
      return;
    }
    this._callRepo.SpecialityCode = this.specialCode;
    this._callRepo.PatientCode = this.callData.patCode;
    this._callRepo.DocId = this.DoctorCode;
    this._callRepo.CallData = { ...this.callData, specialityCode: this.callData.specialization } as any;
    return patientdata;
  }
  time: any


  savedDataSerial: number;
  showSavedCallerData : boolean;
  callApiToSave(patientdata: TotalData) {
    if (this.callCenterReservationForm.invalid && this.callData.serial < 0) {
      let _invalid = findInvalidControls(this.callCenterReservationForm);
      if (_invalid.length > 0) {
        let errorText = ''
        _invalid.forEach((element, index) => {
          errorText += (element + ((_invalid.length > (index + 1)) ? " , " : ""));
        });
        this._toastService.activateMsg('GeneralError');
        window.alert("Please Fill this Fields ( " + errorText + " )");
      }
      return;
    }
    if (this.sendMessageFlag && (!this.callCenterReservationForm.value.callerPhone && !this.callCenterReservationForm.value.mobile)) {
      this._toastService.activateMsg('Pleses Complete patient Number ');
      return -1;

    }
    // if (getDateObj(this.callCenterReservationForm.value.reservationDate) < new Date()) {
    //   this._toastService.activateMsg('لا يمكن تسجيل  مكالمه بتاريخ مسبق');
    //   return;
    // }
    if (this.componentType != 3) {
      if (patientdata.callData && this.time) {
        patientdata.callData.reservationDate = this.time;//  getDateObj(this.callCenterReservationForm.value.reservationDate, this.time);
      } else {
        patientdata.callData.reservationDate = getDateObj(this.callCenterReservationForm.value.reservationDate)
      }
    }

    if (this.callerData && this.callData.serial > 0) {
      this._callCenterReservationService.updateCallerData(patientdata)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c["returnFlag"]) {
            this.resetForm();
            this.activeSelect = false
          }
        },
          err => console.log(err),
          () => {
            this.existedPatient = false;
            this.showClientCallData = false
            this.emitSaveSuccesOrBackStatus.emit(true)
         //   this.resetForm();
         this.goBack()
          });
    }
    else {
      this._callCenterReservationService.addCallerData(patientdata)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c["returnFlag"]) {
            if (c.data && c.data.length > 0) {
              this.savedDataSerial = c.data[0].serial
              if (this.savedDataSerial > 0) {
                this.showSavedCallerData = true
                this.getSavedPatientData(this.savedDataSerial)
              }
              this._userSessionService.setSessionKey("CUSTOMERSERIAL", c.data[0].serial)
            }
            //send sms message in reservation
            //reservation&reservationDone&clinic
            if (this.sendMessageFlag) {
              this.callDataSerial = c.data[0].serial
              this.saveMessagesLog()
            }
            //this.resetForm();
            this.activeSelect = false
            this.goBack() 

          }
        },
          err => console.log(err),
          () => {
            this.existedPatient = false;
            this.showClientCallData = false;
            this.resetForm();
          });
    }
  }
  savedPatientData = <any>{}
  getSavedPatientData(savedDataSerial) {
    // this._userSessionService.setSessionKey("CallCenterReservationSavedPopupComponent", savedData)
    // this.dynamicComponent = CallCenterReservationSavedPopupComponent;
    // this.content.openModal("CallCenterReservationSavedPopupComponent", CallCenterReservationSavedPopupComponent, savedData);

    this.searchObj['serial'] = savedDataSerial
    this.searchObj.offset = 0;
    this.searchObj.pageSize = 10;
    if (savedDataSerial && savedDataSerial > 0) {
      this.savedPatientData = <any>{}
      this._callCenterService.getCallsData(this.searchObj)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res && res.data && res.data.length > 0) {
              this.savedPatientData = res.data[0];
            }
          },
          error => console.log(error),
          () => {
          });
    }

  }

  onReservationAgainClick() {
    this.getDataForCallerBeneficiaryByPhoneNumber(this.savedPatientData.phoneNumber);
    this.showSavedCallerData = false;
  }

  getDataForCallerBeneficiaryByPhoneNumber(CallerBeneficiaryMobile){
    this.checkMobile = CallerBeneficiaryMobile;
    this.checkMobile = this.checkMobile.replace(/\s/g, "");
    if ((+this.callCenterReservationForm.value.customerId) > 0 ||
      +this.callCenterReservationForm.value.previousPatient > 0) {
      this.addSecMobileNumber = true;
      return false;
    }
    this._callCenterReservationService.checkCallDataPhoneNumber({ mobile: this.checkMobile })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res && res.data && res.data.length > 0) {
          this.existedPatient = false;
          this.showClientCallData = true;
          this.addSecMobileNumber = false;
          this.callCenterReservationForm.get('customerId').setValue(res.data.code)
          this.getClientData(res.data[0])
        }
      })
  }
  //
  //--
  getPatientFromForm(): any {
    let dummy = <ErPatient>(this.callCenterReservationForm.value);
    let formValue = Object.assign({}, dummy);
    formValue.code = formValue.code ? formValue.code : 0;
    formValue.titleCode = formValue.titleCode;
    formValue.fnameAr = formValue.name.fnameAr;
    formValue.fnameEn = formValue.name.fnameEn;
    formValue.snameAr = formValue.name.snameAr;
    formValue.snameEn = formValue.name.snameEn;
    formValue.tnameAr = formValue.name.tnameAr;
    formValue.tnameEn = formValue.name.tnameEn;
    formValue.lnameAr = formValue.name.lnameAr;
    formValue.lnameEn = formValue.name.lnameEn;
    // formValue.fullnameAr = this.nameComponent ? this.nameComponent.getFullNameAr() : null;
    // formValue.fullnameEn = this.nameComponent ? this.nameComponent.getFullNameEn() : null;
    //--------------------------------------------------------------------------------
    formValue.fullnameAr = this.callCenterReservationForm.get('name.fullnameAr').value;
    formValue.fullnameEn = this.callCenterReservationForm.get('name.fullnameEn').value;
    formValue.countryCode = formValue.address.countryCode;
    formValue.govCode = formValue.address.govCode;
    formValue.cityCode = formValue.address.cityCode;
    formValue.villageCode = formValue.address.villageCode;
    formValue.nationalityId = formValue.address.nationalityId;
    formValue.mobile = formValue.mobile;
    formValue.mobile2 = formValue.mobile2;
    formValue.homePhone = formValue.homePhone;
    formValue.fullAddressAr = formValue.address.fullAddressAr;
    formValue.fullAddressEn = formValue.address.fullAddressEn;
    formValue.birthDate = this._sharedDateService.convertFromNgBsToDate(formValue.birthDateNgb);
    formValue.identityType = formValue.identity.identityType;
    formValue.identityValue = formValue.identity.identityValue;
    formValue.birthDate = this._sharedDateService.convertFromNgBsToDate(formValue.birthDateNgb);
    //------------ services level values ---------------------------------------------
    if (this.callCenterReservationForm.get('patientServiceLevelOne').value > 0) {
      formValue.serviceCode = this.callCenterReservationForm.get('patientServiceLevelOne').value
    }


    if (this.callCenterReservationForm.get('patientServiceLevelTwo').value > 0) {
      formValue.serviceCode = this.callCenterReservationForm.get('patientServiceLevelTwo').value
    }

    if (this.callCenterReservationForm.get('patientServiceLevelThree').value > 0) {
      formValue.serviceCode = this.callCenterReservationForm.get('patientServiceLevelThree').value
    }

    if (this.showExpectedServices) {
      formValue.patExpectedFlag = 1
    }
    formValue.expectedDate = this._sharedDateService.convertFromNgBsToDate(formValue.expectedDate);
    formValue.doctorID = formValue.doctorID;
    formValue.cost = formValue.cost;
    formValue.leadType = formValue.leadType;
    formValue.howToReachUs = formValue.howToReachUs;
    formValue.parentId = formValue.parentId;
    formValue.contractId = formValue.therapeuticCards.contractId
    console.log('***********formValue*****formValue', formValue)
    return formValue;
  }
  //---------------------------------------------------------------------------------------------------------------------
  setPatientToForm(patient: ErPatient) {

    patient.name = patient.name ? patient.name : this.nameComponent.getNameObjFromModel(patient);//getNameObjFromModel
    patient.address = patient.address ? patient.address : this.addressComponent.getAddressObjFromModel(patient);//getAddressObjFromModel
    patient.identity = <IIdentity>{};
    patient.birthDateNgb = this._sharedDateService.convertFromDateToNgBsObject(patient.birthDate);

    (<UntypedFormGroup>this.callCenterReservationForm).patchValue(patient, { onlySelf: true, emitEvent: false });
    this.callCenterReservationForm.get('identity').patchValue({
      identityType: patient.identityType,
      valueFormated: '',
      identityValue: patient.identityValue,
      gender: patient.gender,
    }, { emitEvent: false });

    if (patient["AddNew"] && patient.identityValue) {
      this.identityComponent.onIdentityValueBlur();
    }
  }
  openDoctorMonthDates() {
    if (!this.callCenterReservationForm.get('docId').value) {
      this._toastService.activateMsg('UI33');
      return
    }
    let requestDate = new Date()
    let outpatientParms: any = {}
    outpatientParms.ReservationDate = requestDate;
    outpatientParms.entityType = 3;
    outpatientParms.ResourceType = 100;
    // outpatientParms.docIdArr = this.docIdArr;

    outpatientParms.resourceId = this.callCenterReservationForm.get('docId').value;
    outpatientParms.vPlace = this.callCenterReservationForm.get('clinicCode').value;
    outpatientParms.patCode = (this.callerData == undefined) ? null : this.callerData.patCode;
    // الكول سنتر اللى هيحجز مش الدكتور azmio
    outpatientParms.patientRservedByDoctorInCallCenter = 1
    this.dynamicComponent = DoctorReservationComponent;
    this.content.openModal("DoctorReservationComponent", "masterParms", outpatientParms);
    this._userSessionService.setSessionKey('_outpatientParms', outpatientParms);

  }
  //sayed check the mobile number already exsit
  checkMobile = <any>{};
  onKeyMobile(event: any) {
    this.parentId = this.callCenterReservationForm.get("parentId").value
    this.checkMobile
    this.checkMobile = event.target.value;
    this._callCenterReservationService.getPatientMobile({ mobile: this.checkMobile, parentId: this.parentId })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res && res.data && res.data[0]) {
          this._toastService.activateMsg('UI411');
        }
        else {
          false
        }
      }
      )
  }

  handleCallerPhoneKeyEnter() {
    let _callerPhone = this.callCenterReservationForm.get('callerPhone').value;
    this.onMobileChange(_callerPhone)

  }

  onMobileChange(_callerPhone) {
    let lastIndex: number
    this.checkMobile
    this.checkMobile = _callerPhone;
    this.checkMobile = this.checkMobile.replace(/\s/g, "");
    if ((+this.callCenterReservationForm.value.customerId) > 0 ||
      +this.callCenterReservationForm.value.previousPatient > 0) {
      this.addSecMobileNumber = true;
      return false;
    }
    this._callCenterReservationService.checkCallDataPhoneNumber({ mobile: this.checkMobile })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res && res.data1 && res.data1.length > 0) {      //-----مريض تم حجزة مسبقا
          lastIndex = res.data1.length - 1
          this.existedPatient = true;
          this.showClientCallData = true;
          this.addSecMobileNumber = false;
          this.callData.patCode = res.data1[lastIndex].patCode
          this.callCenterReservationForm.get('callerName').setValue(this.patNameAr)
          this.previousPatientSelectize.clearItems();
          this.previousPatientSelectize.clear();
          this.callCenterReservationForm.get('patCode').setValue(this.callData.patCode)
          this.callCenterReservationForm.get('previousPatient').setValue(this.callData.patCode)

          this.getClientData(res.data1[0], true);
        }

        else if (res && res.data && res.data.length > 0) {
          this.existedPatient = false;
          this.showClientCallData = true;
          this.addSecMobileNumber = false;
          this.getClientData(res.data[0])
        }
        else {
          this.existedPatient = false;
          this.showClientCallData = false;
          this.addSecMobileNumber = true;
          this.callCenterReservationForm.reset()
          this.callCenterReservationForm.get('callerPhone').setValue(this.checkMobile);
          this.callCenterReservationForm.get('mobile').setValue(this.checkMobile);
          this.callCenterReservationForm.get('callResult').setValue(1);
          this.callCenterReservationForm.get('reservationType').setValue(2);
          this.callCenterReservationForm.get('callmethod').setValue(1);
          this.callCenterReservationForm.get('callReason').setValue(3);
        }
      })
  }



  getClientData(data, exisitedPatFalg?: boolean) {
    if (data) {
      this.cCCallBenficaryCode = data.code,
        this.searchObj.cCCallBeneficiarySerial = this.cCCallBenficaryCode
      this.searchObj.patCode = exisitedPatFalg ? this.callData.patCode : null;
      this.callCenterReservationForm.get('clientCode').setValue(this.cCCallBenficaryCode)
      this.getCallData()
    }
  }
callerCode: number;
  getCallData() {
    this.searchObj.offset = 0;
    this.searchObj.pageSize = 10;
    this.searchObj.callTypeFlag = this.callTypeFlag
    this.searchObj.serial = this.savedDataSerial ? this.savedDataSerial : null
    this.callerData = null
    this.callerCode = null ;
    this.CallDataList = [];
    this.showClientCallData = false;
    this._callCenterService.getCallerDataSerach(this.searchObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
         
          if (res && res.data && res.data.length > 0) {
            this.callerData = res.data[0];
            this.callerCode  =  this.callerData.callerCode
            this.CallDataList = res.data
            this.showClientCallData = true;

          }
          else {
            this.showClientCallData = false;
          }

          if (res && res.data1 && res.data1.length > 0) {
            this.callerData.visitSerial = res.data1[0].lastVisitSeial
          }

        },
        error => console.log(error),
        () => {
          let _phoneNumber = ((+(this.checkMobile) > 0) ? this.checkMobile : this.callerData.phoneNumber);
          let _Code = this.callerData.ccCallBeneficiarySerial ? this.callerData.ccCallBeneficiarySerial : this.callerData.patCode
          console.log('___phoneNumber__' + this.callerData.phoneNumber)
          console.log('___phoneNumber__' + this.checkMobile)
          this.callerData = Object.assign(this.callerData, {
            callmethod: this.formValAfterSettings["callmethod"],
            reservationType: this.formValAfterSettings["reservationType"]
          });


          this.setControls(this.callerData)
          this.callData.dataStatus = 1
          this.callData.cCCallBeneficiarySerial = this.callerData.ccCallBeneficiarySerial;
          this.callData.patCode = this.callerData.patCode;
          this.callCenterReservationForm.get('code').setValue(_Code);
          if (this._formServiceSettings.formJsonObj["reservationDate"].setDefault)
            this.callCenterReservationForm.get('reservationDate').setValue(this._sharedDateService.convertFromDateToNgBsObject(new Date()));
          this.callCenterReservationForm.get('callNotes').setValue('');
          this.callCenterReservationForm.get('callerPhone').setValue(_phoneNumber);
          this.callCenterReservationForm.get('specialization').setValue('');
          this.callCenterReservationForm.get('clinicCode').setValue('');
          //   this.callCenterReservationForm.get('branchAddress').setValue('');

          this.callCenterReservationForm.get('callSort').setValue(this.callerData.rowsCount);



          if (this.checkMobile && this.callerData.phoneNumber && this.callerData.phoneNumber != this.checkMobile) {
            this.addSecMobileNumber = true;
          }
          this.checkLeadsData()
          this.searchObj = <EmergencyParms>{}
          this._formServiceSettings.setDefaultsForSomeKeys(this.callCenterReservationForm as UntypedFormGroup, ['callReason', 'reservationType', 'callResult', 'branchAddress']);

        });
  }


  checkLeadsData() {
    this.markPatExpectedServiceSearchObj.patCode = this.callerData.patCode ? this.callerData.patCode : null
    this.markPatExpectedServiceSearchObj.cCCallBeneficiary = this.callerData.ccCallBeneficiarySerial ? this.callerData.ccCallBeneficiarySerial : null
    this._MarkPatExpectedServiceService.getLeadsByDoctors(this.markPatExpectedServiceSearchObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        requests => {
          if (requests && requests.data && requests.data.length > 0) {
            this.showLeads = true;
          }
          else {
            this.showLeads = false;
          }
        },
        error => console.log(error),
        () => {
        });
  }

  addPhone() {
    let _phone = this.callCenterReservationForm.get('callerPhone').value
    let _previousPatient = this.callCenterReservationForm.get('previousPatient').value
    let _customerId = this.callCenterReservationForm.get('customerId').value
    if (_phone && (_previousPatient || _customerId)) {
      this._modalService.activeMes('هل تريد اضافه هذا الرقم الى بيانات المتصل' + this.checkMobile,
        'Do you want to add this phone number to caller Data' + this.checkMobile).then(responseOK => {
          if (responseOK) {
            console.log('______________respone OK ' + this.checkMobile)
            this.callData.secoundMobile = this.checkMobile;
            this.callCenterReservationForm.get('mobile2').setValue(this.checkMobile);
            //------------------------------
            this.callData.cCCallBeneficiarySerial = _customerId
            this.callData.patCode = _previousPatient
            this.callData.secoundMobile = this.checkMobile
            this.callData.dataStatus = 2
            let totalCallData = <TotalData>{
              callMainData: null,
              callData: this.callData,
              mark_Leads: null
            };

            //------------------------------
            this._callCenterReservationService.addSecoundPhoneNumber(totalCallData)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                res => { }
              )
            //---------------------------------------
          }
        });
    }

    else {
      this._toastService.activateMsg("UI418");
      return false;
    }
  }

  //   getEarliestDate(){
  //     this._userSessionService.setSessionKey("resourceData", {resourceType:1,resourceId:1})
  //         this.dynamicComponent = ResourceFreeDatesComponent ;
  //         this.content.openModal("ResourceFreeDatesComponent ", "callData", this.CallDataList);
  //   }


  ModalTitle: string = 'Allergy Data';
  compType: number = 0;
  addMedicalDataPopup(size?: "sm" | "lg" | "xl", modalTitle?: string, type?: number) {
    if (modalTitle) {
      this.ModalTitle = modalTitle;
    }
    // set component type
    this.compType = type ? type : 0;
    // create object with master data
    let masterParms = {};
    //send data when model open
    this._userSessionService.setSessionKey('visitData', {
      serial: this.callerData.visitSerial,
      docId: this.callerData.docId,
      editableContent: true,
      patCode: this.callData.patCode
    });

    this.content2.openModal("MedicalDataPopupComponent", "masterParms", masterParms, size);
  }
  showAll(action) {

    if (action == 6687) {    /// show all calls
      this._userSessionService.setSessionKey("CallDataList", this.CallDataList)
      this.callListDynamicComponent = CallDataPopUpComponent;
      this.callListContent.openModal("CallDataPopUpComponent", "callData", this.CallDataList);
    }
    else if (action == 6688) {  /// show pat visits and services
      this._userSessionService.setSessionKey("patientCallCenter", this.callerData)
      this.callListDynamicComponent = CallDataPatVisitsServicesComponent;
      this.callListContent.openModal("CallDataPatVisitsServicesComponent", "patient", this.callerData);
    }
    else if (action == 6689) {  /// show pat Leads
      let _Obj = <any>{}
      _Obj.patCode = this.callerData.patCode
      _Obj.ccCallBeneficiarySerial = this.callerData.ccCallBeneficiarySerial
      this._userSessionService.setSessionKey("patientCallLeads", _Obj)
      this.callListDynamicComponent = CallDataShowLeadsCallsComponent;
      this.callListContent.openModal("CallDataShowLeadsCallsComponent", "patientCallLeads", this.callerData.patCode);
    }
    if (action == 6969) {
      this.getSalesOrderHistory();

    }
    if (action == 7004) {
      this.addMedicalDataPopup('lg', 'CHRONIC', 200);
    }
    if (action == 2132) {
      // Service history
      this.servicesHistory();
    }
    if (action == 7350) {
      this.showOldSystemHistory();
    }
  }

  showOldSystemHistory() {
    this.callerData['code'] = this.callerData['patCode']
    this._userSessionService.setSessionKey('PatientListComponent', this.callerData);
    this.dynamicComponent = RegpatHistoryOnOldSystemComponent;
    this.content.openModal("RegpatHistoryOnOldSystemComponent", "PatientListComponent", this.callerData);
  }
  servicesHistory() {
    let _Obj = <any>{}
    _Obj.patCode = this.callerData.patCode
    this.dynamicComponent = ServiceHistoryComponent;
    this.content.openModal("ServiceHistoryComponent", "Reservations", _Obj);

  }
  getCustomerData(cust) {

    if (cust && cust.code && cust.AutoEmited == false) {
      this.showClientCallData = true;
      this.showSavedCallerData  = false
      this.existedPatient = false;
      this.searchObj = <EmergencyParms>{}
      this.callCenterReservationForm.get('previousPatient').setValue(null)
      this.searchObj.cCCallBeneficiarySerial = cust.code
      this.previousCallsSelectize.clearItems();
      this.previousCallsSelectize.clear();
      this.getCallData()
    }
  }
  patCode: number
  getPreviosPatData(pat) {
    if (this.reloadData) {
      if (pat && pat.code) {
        this.showClientCallData = true;
        this.showSavedCallerData  = false
        this.patCode = pat.code
        this.existedPatient = true;
        this.searchObj = <EmergencyParms>{}
        this.callCenterReservationForm.get('customerId').setValue(null)
        this.searchObj.patCode = pat.code
        this.previousCallsSelectize.clearItems();
        this.previousCallsSelectize.clear();
        this.getCallData()

      }
    }
  }

  orderType: number;
  addOrder(order) {
    if (order && order.code) {
      this.orderType = order.code;
      if (this.existedPatient) {
        if (this.orderType == 1 || this.orderType == 3 || this.orderType == 4) {
          this.setVisitData();
          this._callRepo.totalPatientData = this.prepareDataToSave();
          this._userSessionService.setSessionKey('patientTransfer', this._callRepo.CallData);
          this._callRepo.setNewPatReservation(6743);
          // this.dynamicComponent = OrderAddComponent;
          // this.content.openModal("OrderAddComponent", "Reservations");
        }
      }

    }

  }

  getDeviceSlotTime(ev) {
    if (ev && ev.code && this.orderType == 3) {
      this.listeningGuid = 'Free_Dates'
      this._userSessionService.setSessionKey('resourceData' + this.listeningGuid, [{ entityType: 4, resourceType: 2, resourceId: ev.code, activeResource: 1 }]);
    }
  }


  activeSelect: boolean = false;
  msgTemplateData: any
  addSelect(ev: any) {
    if (ev && ev.code && !ev.AutoEmited) {
      this.getLastPatientForEdit(ev.code);
      this.callCenterReservationForm.get('code').setValue(ev.code);
    }
  }


  getLastPatientForEdit(code: any) {
    if (code) {
      this._callCenterReservationService.getLastPatientForEdit(code)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res && res.data) {
              this.callerData = res.data[0];
              if (this.callerData) {
                this.setControls(this.callerData);
              }
            }
          }
        )
    }
  }


  registeration: number
  reasonFun(ev) {
    if (ev && ev.code) {
      this.reason = ev.code;
      this.registeration = ev.code
      console.log('Code', ev.code)
      if (ev.code == 1) {
        this._userSessionService.setSessionKey("patient", { code: this.callerData ? this.callerData.patCode : null });
        this.callCenterReservationForm.get('callResult').setValue('2');
      }
      if (ev.code == 2) {
        this.callCenterReservationForm.get('callResult').setValue('3');
      }
      if (ev.code == 3) {
        this.callCenterReservationForm.get('callResult').setValue('1');
      }
      if (ev.code == 5) {
        this.callCenterReservationForm.get('callResult').setValue('4');
      }
      this.callCenterReservationForm.get('callResult').clearValidators();
      this.callCenterReservationForm.get('callResult').updateValueAndValidity();
    }
    else {
      this.reason = null;
      this.callCenterReservationForm.get('callResult').setValue(null);
    }
  }

  setVisitData() {
    this._userSessionService.setSessionKey('visitData', {
      serial: this.callerData.visitSerial,
      docId: null,
      contractId: null,
      visitNo: null,
      patCode: this.callData.patCode,
      orderType: 17
    });
  }
  onChange(event) {
    if (event != '') {

      let x = (new Date().getFullYear() - event);
      let dob_date = new Date(x, 0, 1);
      this.callCenterReservationForm.patchValue({
        birthDateNgb: this._sharedDateService.convertFromDateToNgBsObject(dob_date)
      });
    }
  }

  existedPatientFun(check) {
    if (check == true) {
      this.existedPatient = true;
      this.componentType != 3;
    }
    if (check == false) {
      this.existedPatient = false;
    }
  }


  //goBack function
  goBack(): void {
    this.emitSaveSuccesOrBackStatus.emit(true);
  }
  cancelRegister(): void {
    this.activeSelect = false;
    this.callCenterReservationForm.reset();
    this.emitSaveSuccesOrBackStatus.emit(true);
  }

  resetForm() {

    let date = this._sharedDateService.convertFromDateToNgBsObject(new Date());
    this._userSessionService.setUIStateAction({ type: UIAction.CommitTrans, payload: this.currentTrans['InPatientReservation'] });
    this.callCenterReservationForm.reset();
    this._userSessionService.removeSessionKey('callerInfo');
    this.callCenterReservationForm.get('leadType').setValue(1)
    this.callCenterReservationForm.get('expectedDate').setValue(date);

    this.setDefaultsAndValidators(true);
  }
  setDefaultsAndValidators(setDefaults: boolean) {

    this._formServiceSettings.setFormSettings(
      this.callCenterReservationForm as UntypedFormGroup,
      this.componentType == 3 ? 'expectedlead' : 'callCenter',
      this.formValAfterSettings,
      setDefaults, 'setting'

    );


  }


  getSalesOrderHistory() {
    let patCode = this.callCenterReservationForm.value.previousPatient
    console.log('patCode', patCode)
    this._userSessionService.setSessionKey("OpenSalesOrderHistory", {
      code: patCode,
      serviceId: this.callCenterReservationForm.value.serviceID
    })
    this.dynamicComponent = SalesOrderHistoryPopUpComponent;
    this.content.openModal("SalesOrderHistoryPopUpComponent", "Reservations", { code: patCode, serviceId: this.callCenterReservationForm.value.serviceID });

  }

  onpopupClose(parms: any) {
    if (parms && parms.output == 'Cross click') {
      if (parms.name == 'CallDataShowLeadsCallsComponent') {
        this._userSessionService.setSessionKey("patientCallLeads", null)
      }

      if (parms.name == 'CallDataPatVisitsServicesComponent') {
        this._userSessionService.setSessionKey("patient", null)
      }
      if (parms.name == 'MedicalDataPopupComponent') {
        this._userSessionService.setSessionKey("visitData", null)
      }

      if (parms.name == 'SalesOrderHistoryPopUpComponent') {
        this._userSessionService.setSessionKey("resetSalesOrderHistory", null)
      }

    }
  }








  ///////////////////////////////////////////////////////////////////////////
  @ViewChild('specialitySearch') specialitySearch: SelectizeComponent;
  @ViewChild('doctorSearch') doctorSearch: SelectizeComponent;
  @ViewChild('clinicSearch') clinicSearch: SelectizeComponent;
  @ViewChild('serviceSelectize') serviceSelectize: SelectizeComponent;
  specialCode: number;
  DoctorCode: number;
  ShiftCode: number;
  reservationDateClicked(ev) {
    if (this.speciallity)
      this.speciallity['AutoEmited'] = false
    this.specialityClicked(this.speciallity)
  }
  speciallity: any
  specialityClicked(item: any) {
    this.DoctorCode = null
    this.speciallity = item ? item : null;
    this.specialCode = item ? item.code : null;

    if (this.specialCode == null) {
      this._userSessionService.setSessionKey('speciality', {});
      return false;
    }

    this._userSessionService.setSessionKey('speciality', item);

    if (!item['AutoEmited']) {
      this.doctorSearch.setFastSearchKey('SpecialityId', item.code);
      this.clinicSearch.setFastSearchKey('SpecialityId', item.code);
      this.doctorSearch.setFastSearchKey('ReservationDate', this.callCenterReservationForm.value.reservationDate ? this._sharedDateService.convertFromNgBsToDate(this.callCenterReservationForm.value.reservationDate) : new Date());
      this.clinicSearch.setFastSearchKey('ReservationDate', this.callCenterReservationForm.value.reservationDate ? this._sharedDateService.convertFromNgBsToDate(this.callCenterReservationForm.value.reservationDate) : new Date());
      this.doctorSearch.setFastSearchKey('ShiftId', this.ShiftCode);
      this.doctorSearch.setFastSearchKey('ResourceType', 100);
      this.doctorSearch.clear();
      this.doctorSearch.clearItems();
      this.clinicSearch.clear();
      this.clinicSearch.clearItems();
    }

    this.specialitySearch.toggleDropdown = false;
  }

  // *********************************************** doctor seletize *********************************************************
  doctorName: any
  shortDoctorName: any
  doctorClicked(item: any) {
    if (item && item.code > 0) {
      this.DoctorCode = item ? item.code : null;
      this.doctorName = item.nameAr
      this.shortDoctorName = item.shortNameAr
      if (item && item.apologizeFlag == 1) {
        this._toastService.activateMsg('UI122');
        this._userSessionService.setSessionKey('doctor', {});
        //this.DoctorCode = null;
        return false;
      }

      if (this.DoctorCode == null) {
        this._userSessionService.setSessionKey('doctor', {});
        return false;
      }
      this._userSessionService.setSessionKey('doctor', item);
      this.doctorSearch.toggleDropdown = false;
      // if(this.callCenterReservationForm.get('reservationDate').value){

      this.setOutpatientParms();
      // }

      if (this.existedPatient) {
        if (this.orderType == 2) {
          this._callRepo.totalPatientData = this.prepareDataToSave();
          this._callRepo.setNewPatReservation(6754);
        }
      }
      this.callResultEnd()
    }
  }

  clinicCode: number;
  clinicClicked(ev) {
    if (ev && ev.code) {
      this.clinicCode = ev.code
    }

    if (this.callCenterReservationForm.get('reservationDate').value) {
      this.setOutpatientParms();
    }

  }

  setOutpatientParms() {
    if (this.specialitySearch != null) {
      let outpatientParms = <OutpatientParms>{};
      outpatientParms.DocCode = this.DoctorCode ? this.DoctorCode : null;
      outpatientParms.vPlace = this.clinicCode ? this.clinicCode : null;
      outpatientParms.ReservationDate = this._sharedDateService.convertFromNgBsToDate(this.callCenterReservationForm.value.reservationDate)

      let speciality = this.specialitySearch.selectizeOptions.selected
      outpatientParms.SpecialityId = speciality ? speciality.code : null;
      outpatientParms.ResourceType = 100;
      outpatientParms.ShiftId = this.ShiftCode;
      this._userSessionService.setSessionKey('_outpatientParms' + this.listeningGuid, outpatientParms);
    }
  }
  currentFreeDate: ResourceFreeDate = <ResourceFreeDate>{};
  /****************************************
    * call after user select slot for service
    * @param selectedSlot
    */
  selectedCurrentSlot(selectedSlot: any) {
    if (selectedSlot) {
      console.log('**********selectedSlot', selectedSlot)

      this.time = selectedSlot.startTimeSlot;
      this.currentFreeDate.startTimeOnly = selectedSlot.startTime
      this.currentFreeDate.expectedStartTime = selectedSlot.startTimeSlot
      this.currentFreeDate.expectedEndTime = selectedSlot.endTimeSlot
      this.currentFreeDate.minutesPerSlot = selectedSlot.minutesPerSlot
      this._userSessionService.setSessionKey('resourceFreeDate', this.currentFreeDate);
      this._userSessionService.setSessionKey('slot', selectedSlot);
      this.getMsgTemplate();
    } else {
      this.time = null;
    }

  }
  reloadData: boolean = true;
  selectedAppointmentCurrentSlot(selectedSlot: any) {
    if (selectedSlot) {

      this.time = selectedSlot.startTimeSlot;
      this.currentFreeDate.startTimeOnly = selectedSlot.startTime
      this.currentFreeDate.expectedStartTime = selectedSlot.startTimeSlot
      this.currentFreeDate.expectedEndTime = selectedSlot.endTimeSlot
      this.currentFreeDate.minutesPerSlot = selectedSlot.minutesPerSlot
      this.reloadData = false;
      // this.callCenterReservationForm.value.docId = selectedSlot.resourceId;
      // this.callCenterReservationForm.value.specialization  = selectedSlot.speciality;
      this.callCenterReservationForm.patchValue({
        docId: selectedSlot.resourceId
      });
      this.callCenterReservationForm.patchValue({
        specialization: selectedSlot.speciality
      });
      this.callCenterReservationForm.patchValue({
        previousPatient: selectedSlot.patCode
      });
      //previousPatient
      // this.callCenterReservationForm.get('patCode').setValue(selectedSlot.patCode)


      // this.callData.patCode = selectedSlot.patCode;
      this._userSessionService.setSessionKey('resourceFreeDate', this.currentFreeDate);
      this._userSessionService.setSessionKey('slot', selectedSlot);
      this.getMsgTemplate();
    } else {
      this.time = null;
    }

  }
  selectedDeviceCurrentSlot(slot) {
    console.log('**********slot', slot)
    if (slot) {
      this.time = slot.startTimeSlot;
      this.currentFreeDate.startTimeOnly = slot.expectedStartTime
      this.currentFreeDate.expectedStartTime = slot.expectedStartTime
      this.currentFreeDate.expectedEndTime = slot.expectedEndTime
      this.currentFreeDate.minutesPerSlot = slot.minutesPerSlot

      this._userSessionService.setSessionKey('resourceFreeDate', this.currentFreeDate);
      this._userSessionService.setSessionKey('slot', slot);
      this.getMsgTemplate();
    }
  }
  getReservationsTime() {
    if (this.specialitySearch.selectizeOptions.selected != undefined && this.callCenterReservationForm.value.reservationDate) {
      let outpatientParms = <OutpatientParms>{};
      outpatientParms.DocCode = this.DoctorCode ? this.DoctorCode : null;
      outpatientParms.ReservationDate = this._sharedDateService.convertFromNgBsToDate(this.callCenterReservationForm.value.reservationDate)
      let speciality = this.specialitySearch.selectizeOptions.selected ? this.specialitySearch.selectizeOptions.selected : null
      outpatientParms.SpecialityId = speciality.code ? speciality.code : -1
      outpatientParms.ResourceType = 100;
      outpatientParms.ShiftId = this.ShiftCode;
      if (outpatientParms.SpecialityId != -1) {
        this._userSessionService.setSessionKey('_callReservation', outpatientParms);

        this.callListDynamicComponent = ReservationCallComponent;
        this.callListContent.openModal("ReservationCallComponent", "_callReservation", outpatientParms);
      } else {

      }
    } else {
      this._toastService.activateMsg('UI35');
    }
  }
  templateMsg: string = ''
  getMsgTemplate() {
    this.msgTemplate.fieldName = 'reservationPatientSMS'
    this.msgTemplate.reservationDate = this._sharedDateService.convertFromNgBsToDate(this.time);
    this.msgTemplate.specialityId = this.callCenterReservationForm.value.specialization;
    this.msgTemplate.empId = this.DoctorCode
    this._SmsService.getMsgTemplate(this.msgTemplate)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data) {
            this.msgTemplateData = res.data[0];
            this.templateMsg = this.msgTemplateData.smsTemplate
            this.hideSendMessageBox = this.msgTemplateData.sendSmsFlag
          }
        }
      )
  }
  callResultEnd() {

    if (this.registeration == 3 && this.callCenterReservationForm.value.callResult == 1 && this.callCenterReservationForm.value.reservationType == 2) {
      //  this.sendMessageFlag = false;
      //  this.getMsgTemplate();//get template msg speciality Doctor

      this.hideSendMessageBox = true;
    }

    else {
      // this.sendMessageFlag = false;
      this.hideSendMessageBox = false;
    }


  }


  
  callDataSerial: number
  //data of sms message
  saveMessagesLog() {
    //get template message
    if (this.msgTemplateData) {
      if (this.msgTemplateData.smsTemplate) {
        //create message
        this.replacrDatainSms()
        this.messagesLog.serial = -1
        this.messagesLog.patCode = this.patCode
        this.messagesLog.message = this.msgTemplateData.smsTemplate
        this.messagesLog.sentDate = new Date()
        this.messagesLog.sender = +JSON.parse(sessionStorage.getItem('currentUser')).userID
        this.messagesLog.mobile = this.callCenterReservationForm.value.callerPhone ? this.callCenterReservationForm.value.callerPhone : this.callCenterReservationForm.value.mobile;
        this.messagesLog.callDataSerial = this.callDataSerial
        this.messagesLog.messageType = 3 //رساله تاكيد حجز مريض
        this._SmsService.RemindingBookingMsg([this.messagesLog])
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => {
             if (res && res.returnFlag  && this.goBackToHomePageFlag  == 1)
             {  
              this.goBack();
            }
          })
      }
    }
  }
  replacrDatainSms() {
    //let SmsData:any
    let SmsData = <any>{
      reservationDate: this.time,
      doctorName: this.doctorName,
      shortDoctorName: this.shortDoctorName
    };
    this.msgTemplateData.smsTemplate = this._SmsService.replaceSmSMsgData(SmsData, this.templateMsg)
    console.log(this.msgTemplateData.smsTemplate)

  }
  orderServiceTypeFlag: boolean = false
  onServicsClicked(item) {
    if (item) {
      let orderServiceType = item.serviceType

      if ([13, 14, 15].includes(orderServiceType))//اخفاء في حاله القسطره والمناظير والتخدير
        this.orderServiceTypeFlag = true
      else
        this.orderServiceTypeFlag = false

    }
  }
}
